$(function () {
    $('.delete-image-in-step').click(function () {
        if (!confirm('Delete image?')) {
            return false;
        }

        var data = {
                id: $(this).data('id'),
                index: $(this).data('index'),
            },
            url = '/api/steps/' + data.id + '/delete-image',
            $this = $(this);
        axios
            .patch(url, data)
            .then(() => {
                $this.parent().remove();
            })
            .catch(() => {
                alertify.error('An error occurred while deleting the image.');
            });

        return false;
    });
});
